import './assets/vue-material.scss'
import 'maptalks/dist/maptalks.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import VueMaterial from 'vue-material'
import Notifications from 'vue-notification'
import VueTheMask from 'vue-the-mask'

import environment from '@/environment'
import validationFormMixin from '@/mixins/validation.mixin'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.use(VueTheMask)

Vue.config.productionTip = false

Vue.use(VueMaterial)

// https://github.com/vuematerial/vue-material/issues/2285
Vue.component(
  'MdSelect',
  Vue.options.components.MdSelect.extend({
    methods: {
      isInvalidValue: function isInvalidValue() {
        return this.$el.validity
          ? this.$el.validity.badInput
          : this.$el.querySelector('input').validity.badInput
      },
    },
  })
)

Vue.material.locale = {
  // ...Vue.material.locale,
  // range for datepicker
  startYear: 1900,
  endYear: 2099,

  // date format for date picker
  dateFormat: 'dd/MM/yyyy',

  // i18n strings
  days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  shorterDays: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  shortMonths: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dec',
  ],
  shorterMonths: [
    'J',
    'F',
    'M',
    'A',
    'M',
    'Ju',
    'Ju',
    'A',
    'Se',
    'O',
    'N',
    'D',
  ],

  // `0` stand for Sunday, `1` stand for Monday
  firstDayOfAWeek: 0,

  cancel: 'Cancel',
  confirm: 'Ok',
}

Vue.use(VueApexCharts)

Vue.use(Notifications)

Vue.component('Apexchart', VueApexCharts)

Vue.mixin(validationFormMixin)

Vue.directive('coordinate-decimals', {
  bind(el) {
    el.addEventListener('input', handleCoordinateDecimalInput)
  },
  unbind(el) {
    el.removeEventListener('input', handleCoordinateDecimalInput)
  },
})

function handleCoordinateDecimalInput(e) {
  const [int, dec] = e.target.value.split('.')
  if (dec && dec.length > 6) {
    e.target.value = `${int}.${dec.slice(0, 6)}`
    e.target.dispatchEvent(new Event('input'))
  }
}

// eslint-disable-next-line no-extend-native
Date.prototype.utcToLocalDate = function () {
  const offset = new Date().getTimezoneOffset()
  return new Date(this.getTime() - offset * 60 * 1000)
}

// eslint-disable-next-line no-extend-native
Array.prototype.groupBy = function (getKey) {
  return this.reduce(function (rv, x) {
    const key = getKey(x)

    let data = rv[key]

    if (!data) {
      data = []
    }

    rv[key] = [...data, x]
    return rv
  }, {})
}

Sentry.init({
  Vue,
  dsn: environment.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  attachStacktrace: true,
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    environment.API_URL,
    environment.WS_URL,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  sampleRate: 0.1,
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
